function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomAimacro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "file-code-4",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    id: "secondary",
    points: "19 21 21 19 19 17",
    style: {
      fill: "none",
      stroke: "rgb(44, 169, 188)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "secondary-2",
    "data-name": "secondary",
    points: "15 17 13 19 15 21",
    style: {
      fill: "none",
      stroke: "rgb(44, 169, 188)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-3",
    "data-name": "secondary",
    d: "M7,13h6M7,9h6",
    style: {
      fill: "none",
      stroke: "rgb(44, 169, 188)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M9,21H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3h9l4,4v6",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAimacro);
export default __webpack_public_path__ + "static/media/custom-aimacro.24011181c366290a9643bcd1b2dba5c2.svg";
export { ForwardRef as ReactComponent };